import classNames from "classnames";
import React from "react";
import classes from "./classes.module.scss";
import Button from "../Button";
import Typography, { ITypo, ITypoColor } from "../Typography";
import ArrowLongRight from "../Icons/ArrowLongRight";

type IProps = {
	onClick?: () => void;
	mainTitle: string;
	className?: string;
	options?: IDropdownButtonOption[];
	shouldOpen?: () => boolean;
};

export type IDropdownButtonOption = {
	title: string;
	onClick: () => void;
	icon?: React.ReactNode;
};

export default function DropdownButton({ shouldOpen, onClick, className, mainTitle, options }: IProps) {
	const [isOpen, setIsOpen] = React.useState(false);
	const [hasInteracted, setHasInteracted] = React.useState(false);

	const handleClick = () => {
		if (shouldOpen?.() === false) return;
		setHasInteracted(true);
		setIsOpen((prev) => !prev);
		onClick?.();
	};

	return (
		<div className={classNames(classes["root"], className)}>
			<Button onClick={handleClick}>
				{mainTitle}
				<ArrowLongRight color={ITypoColor.WHITE} />
			</Button>
			<div className={classNames(classes["option-container"], { [classes["init"]!]: !hasInteracted }, { [classes["opened"]!]: isOpen })}>
				{options?.map((option, index) => (
					<div key={index} onClick={option.onClick} className={classes["option"]}>
						{option.icon}
						<Typography typo={ITypo.P_MEDIUM} color={ITypoColor.WILD_SAND_50}>
							{option.title}
						</Typography>
					</div>
				))}
			</div>
		</div>
	);
}
